var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadpdficonsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1649 7.50065V0.833984H18.25L21.1667 3.75065V19.1673H5.33333M17 0.833984V5.00065H21.1667M15.75 15.834V10.0007H19.0833M15.75 12.9173H18.25M4.5 10.0007H4.70833H5.75C7.41667 10.0007 7.625 11.0423 7.625 11.6673C7.625 12.2923 7.41667 13.334 5.75 13.334H4.70833V15.0007H4.5V10.0007ZM9.91667 15.0007V10.0007C9.91667 10.0007 10.7061 10.0007 11.3377 10.0007C12.2851 10.0007 13.25 10.4173 13.25 12.5007C13.25 14.584 12.2851 15.0007 11.3377 15.0007C10.7061 15.0007 9.91667 15.0007 9.91667 15.0007Z",
    stroke: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadpdficonsvg);
export default __webpack_public_path__ + "static/media/downloadpdficonsvg.ccf4be6c9d7923cc4b7576684c7a0f22.svg";
export { ForwardRef as ReactComponent };